import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/base/base.component';


enum Type {
  charter = 'charter',
  fit = 'fit'
}

@Component({
  selector: 'app-heart',
  templateUrl: './heart.component.html',
  styleUrls: ['./heart.component.scss']
})
export class HeartComponent extends BaseComponent implements OnInit {
  @Input() isCharter: boolean = false;
  @Input() selected:boolean = false;
  @Input() code: number = 0;
  @Input() agency?: string = '';
  @Input() viewCard: boolean = true;
  @Input() isWishList: boolean = false;
  private storeFavorite: any = {};


  constructor(private  injector  : Injector,) {
    super(injector);
  }

  ngOnInit(): void {
  }

  getType(): Type {
    return this.isCharter ? Type.charter : Type.fit;
  }

  getLocalStorage(){
    this.storeFavorite = this.getLocalStorageValue('favorites'+this.agency);
  }
}
